import { ElementRef } from "@angular/core"

export function isOutsideComponentClick(elementRef: ElementRef, event: MouseEvent): boolean {
  return isOutsideElementClick(elementRef.nativeElement, event.target as HTMLElement)
}

export function isOutsideElementClick(thisComponent: HTMLElement, targetElement: Node): boolean {
  do {
    if (targetElement === thisComponent) {
      return false
    }

    targetElement = (targetElement as HTMLElement).parentNode
  } while (targetElement)

  return true
}
